module.exports = __webpack_public_path__ + "static/img/news_04.d8b0da1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_04.jpg
// module id = L5Yp
// module chunks = 2